import { NgModule } from '@angular/core';

import { ADD_TO_WISHLIST_FEATURE, CART_WISH_LIST_FEATURE } from '@spartacus/cart/wish-list/root';
import { provideConfig } from '@spartacus/core';


@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        [ADD_TO_WISHLIST_FEATURE]: {
          cmsComponents: ['AddToWishListComponent'],
          module: () => import('./add-to-wish-list').then(({ DpAddToWishListModule }) => DpAddToWishListModule)
        },
        [CART_WISH_LIST_FEATURE]: {
          cmsComponents: ['WishListComponent'],
          module: () => import('./wish-list').then(({ DpWishListModule }) => DpWishListModule)
        }
      }
    })
  ]
})
export class DpWishListFeatureModule {}
